import React, { Children, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import Button from '../Button'
import IconButton from '../IconButton'
import styles from './styles.module.scss'

export default function Modal({
  children,
  isOpen,
  className,
  customContentStyle,
  nested,
  handleClose,
  title,
  subTitle,
  closeOnDocumentClick = false,
  showClose = true,
  showDefaultHeader = true,
  showDefaultSubHeader = true,
  headerCSS,
  closeCSS,
  showOptions = false,
  optionsChildren,
  optionsCSS,
  titleCSS,
  ...rest
}) {
  const { t } = useTranslation()
  const contentStyle = {
    borderRadius: '0.625rem',
    padding: '0.5rem 1rem 2.5rem',
    background: '#fff',
    maxHeight: '95vh',
    overflow: 'auto',
    boxShadow: '0 2px 6px 1px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
  const contentWidth = {
    width: '90%',
    maxWidth: '32.5rem'
  }
  const finalContentWidth = customContentStyle ? customContentStyle : contentWidth
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <Popup
      lockScroll
      className={`${styles.modalContainer} ${className}`}
      contentStyle={{ ...contentStyle, ...finalContentWidth }}
      nested={nested}
      open={isOpen}
      onClose={handleClose}
      closeOnDocumentClick={closeOnDocumentClick}
      {...rest}>
      <div className={styles.modalWrapper} tabIndex={0}>
        {showDefaultHeader && (
          <header className={`${styles.header} ${headerCSS}`}>
            {showOptions && <div className={`${styles.options} ${optionsCSS}`}>{optionsChildren}</div>}
            {showClose && (
              <IconButton
                iconName='close24'
                iconSize='large24'
                onClick={handleClose}
                className={`${styles.closeButton} ${closeCSS}`}
                aria-label={t('global.alert_close')}
              />
              // <button
              //   aria-label={t('global.alert_close')}
              //   type='button'
              //   className={`${styles.closeButton} ${closeCSS}`}
              //   onClick={handleClose}>
              //   <Icon name='close24' />
              // </button>
            )}
          </header>
        )}
        {title && <h1 className={`${styles.title} ${titleCSS}`}>{title}</h1>}
        {showDefaultSubHeader && subTitle && (
          <h2 className={styles.subTitle} dangerouslySetInnerHTML={{ __html: subTitle }} />
        )}

        {children}
      </div>
    </Popup>
  )
}
